module.exports = __webpack_public_path__ + "assets-cabinet/img/mastercard-icon.d64f39b8.svg";